import moment from 'moment'
import Kedo from '@/Kedo.js'
import { BaseDisplayItemProps } from '../../BaseDisplayItem'
import {
    DateFieldExtendedState,
    DateFieldItem,
    DateFieldMode,
    DateFieldValue,
} from './types'
import { normalizeDateFieldValue } from './format'

export function getSearchTypeTitle(kedo: Kedo, searchType: string): string {
    if (!searchType || searchType === 'on') {
        return kedo.t('time_on')
    }

    if (searchType === 'after') {
        return kedo.t('time_after')
    }

    if (searchType === 'before') {
        return kedo.t('time_before')
    }

    if (searchType === 'between') {
        return kedo.t('time_from_till')
    }

    return searchType.charAt(0).toUpperCase() + searchType.slice(1)
}

export function buildDateFieldInitialState(
    props: BaseDisplayItemProps<DateFieldValue, DateFieldItem>,
    mode: DateFieldMode
): DateFieldExtendedState {
    const currentDefault = Boolean(
        props.item.settings?.current_time_as_default ??
            props.item.def_dossier_def_field?.def_field?.settings
                ?.current_time_as_default
    )

    const defaultValue =
        mode === 'datetime'
            ? moment().format()
            : moment().format('YYYY-MM-DD')

    const isSearchMode =
        props.mode === 'search' || props.mode === 'advanced-search'
    const searchValue = props.value as {
        type?: string
        date1?: string | null
        date2?: string | null
    } | null

    let value: DateFieldValue =
        props.value ?? (currentDefault ? defaultValue : null)

    if (mode === 'date') {
        value = normalizeDateFieldValue(value)
    }

    return {
        value,
        show_slider: props.item?.settings?.show_slider === true,
        deadline: props.item?.settings?.deadline ?? null,
        searchType:
            isSearchMode && searchValue?.type ? searchValue.type : 'on',
        date1: isSearchMode && searchValue?.date1 ? searchValue.date1 : null,
        date2: isSearchMode && searchValue?.date2 ? searchValue.date2 : null,
        current_time_as_default: currentDefault,
        restriction:
            props.item?.def_dossier_def_field?.def_field?.settings
                ?.restriction ?? null,
    }
}
